// Kurze Rückmeldung unten mit „Rückgängig“ (z. B. 10 s nach dem Senden)
import { useEffect, useState } from 'react';

type Action = { label: string; run: () => void | Promise<void>; countdown?: boolean };
type ToastItem = { id: number; text: string; action?: Action; until?: number };
let seq = 0;
let setter: ((t: ToastItem | null) => void) | null = null;

export function toast(
  text: string,
  opts: {
    undo?: () => void | Promise<void>;
    action?: { label: string; run: () => void | Promise<void> };
    ms?: number;
  } = {},
) {
  const action: Action | undefined = opts.undo
    ? { label: 'Rückgängig', run: opts.undo, countdown: true }
    : opts.action;
  const item: ToastItem = {
    id: ++seq,
    text,
    ...(action ? { action } : {}),
    until: Date.now() + (opts.ms ?? (opts.undo ? 10_000 : 4_000)),
  };
  setter?.(item);
}

export function Toaster() {
  const [t, setT] = useState<ToastItem | null>(null);
  const [rest, setRest] = useState(0);
  useEffect(() => {
    setter = setT;
    return () => {
      setter = null;
    };
  }, []);
  useEffect(() => {
    if (!t) return;
    const i = setInterval(() => {
      const r = Math.max(0, Math.ceil(((t.until ?? 0) - Date.now()) / 1000));
      setRest(r);
      if (r <= 0) setT((cur) => (cur?.id === t.id ? null : cur));
    }, 250);
    return () => clearInterval(i);
  }, [t]);
  if (!t) return null;
  return (
    <div className="toast" role="status">
      <span>{t.text}</span>
      {t.action && (
        <button
          onClick={() => {
            void t.action?.run();
            setT(null);
          }}
        >
          {t.action.label}
          {t.action.countdown && rest ? ` (${rest})` : ''}
        </button>
      )}
    </div>
  );
}
